<div class="shell" [class.bare]="!showChrome()">
  @if (showChrome()) {
    <nb-sidebar [admin]="true" [ariaLabel]="'shell.adminMenu' | translate">
      <nb-side-brand name="Nabotavle" [sub]="'shell.brandSub' | translate" mark="N" />

      @for (group of navGroups; track group.label) {
        <nb-side-nav-section>{{ group.label | translate }}</nb-side-nav-section>
        @for (item of group.items; track item.path) {
          <nb-side-nav-item
            [active]="isActive(item)"
            [count]="item.badge ? deviations() : null"
            [countLabel]="'shell.count' | translate"
            (activated)="go(item.path)"
          >{{ item.label | translate }}</nb-side-nav-item>
        }
      }

      <nb-side-foot>
        <div class="foot-id">
          <nb-avatar [color]="1" size="m" [initials]="userInitials()" />
          <div class="grow">
            <div class="foot-name">{{ userName() }}</div>
            <div class="foot-role small">{{ 'shell.superuser' | translate }}</div>
          </div>
          <button class="logout" type="button" [attr.aria-label]="'shell.logout' | translate" (click)="logout()"><nb-icon [icon]="LogOut" /></button>
        </div>
      </nb-side-foot>
    </nb-sidebar>
  }

  <div class="main">
    @if (showChrome()) {
      <nb-internal-stripe>{{ 'shell.internalStripe' | translate }}</nb-internal-stripe>

      <nb-topbar [command]="true" [searchPlaceholder]="'shell.searchPlaceholder' | translate" (commandOpen)="cmdOpen.set(true)">
        <!-- Språk — runtime, persisted in localStorage (a platform admin has no tenant profile). Class pinned by i18n.spec. -->
        <nb-segmented
          class="lang"
          [options]="localeOptions"
          [value]="locale.current() ?? 'nb'"
          (valueChange)="setLocale($event)"
          [ariaLabel]="'shell.language' | translate"
        />
        <nb-button variant="pri" size="sm" (click)="go('/opprett')"><nb-icon [icon]="Plus" /> {{ 'shell.createTenant' | translate }}</nb-button>
        <nb-icon-button [web]="true" [label]="'shell.notifications' | translate" [count]="unread()" (click)="openVarsler()"><nb-icon [icon]="Bell" /></nb-icon-button>
        <button class="me" type="button" [attr.aria-label]="'shell.navKonto' | translate" (click)="go('/konto')"><nb-avatar [color]="2" size="s" [initials]="userInitials()" /></button>
      </nb-topbar>
      <nb-command-palette
        [items]="cmdItems()"
        [(open)]="cmdOpen"
        [placeholder]="'palett.placeholder' | translate"
        [ariaLabel]="'palett.ariaLabel' | translate"
        [emptyText]="cmdEmptyText()"
        [loading]="searching()"
        [loadingText]="'palett.searching' | translate"
        (queryChange)="onCmdQuery($event)"
        (picked)="runCmd($event)"
      />
      <nb-toast-host bottom="24px" />
    }

    <main class="content" [class.bare]="!showChrome()">
      <router-outlet />
    </main>
  </div>
</div>
